import { Globe } from "lucide-react";
import { NAV_LINKS, SOCIALS } from "../../data/site";
import { useLanguage } from "../../i18n/LanguageContext";
import { TelegramIcon, TikTokIcon, YoutubeIcon } from "./BrandIcons";

const SOCIAL_ICONS = {
    "telegram-group": TelegramIcon,
    "telegram-channel": TelegramIcon,
    tiktok: TikTokIcon,
    youtube: YoutubeIcon,
    website: Globe,
};

export const Footer = () => {
    const { t } = useLanguage();
    return (
        <footer data-testid="footer" className="border-t border-white/5 bg-nx-base">
            <div className="mx-auto max-w-7xl px-5 py-14 sm:px-6 lg:px-8 lg:py-16">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <a href="#top" data-testid="footer-logo" aria-label="Nexora Global home">
                            <img src="/assets/nexora-logo.png" alt="Nexora Global" className="h-7 w-auto" />
                        </a>
                        <p className="mt-5 max-w-xs text-sm leading-relaxed text-nx-sub">
                            {t("Empowering the Future of Decentralized Finance.")}
                        </p>
                        <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.22em] text-nx-mute">
                            {t("Secure • Transparent • Global")}
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] text-nx-mute">{t("Ecosystem")}</h3>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm font-semibold text-nx-sub transition-colors duration-300 hover:text-nx-text">
                                        {t(l.label)}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a href="#faq" data-testid="footer-link-faq" className="text-sm font-semibold text-nx-sub transition-colors duration-300 hover:text-nx-text">
                                    {t("FAQ")}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] text-nx-mute">{t("Community")}</h3>
                        <ul className="mt-5 space-y-3">
                            {SOCIALS.map((s) => {
                                const Icon = SOCIAL_ICONS[s.key];
                                return (
                                    <li key={s.key}>
                                        <a
                                            href={s.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-testid={`footer-social-${s.key}`}
                                            className="group inline-flex items-center gap-2.5 text-sm font-semibold text-nx-sub transition-colors duration-300 hover:text-nx-text"
                                        >
                                            <Icon size={14} strokeWidth={1.5} className="text-nx-mute transition-colors duration-300 group-hover:text-nx-lime" aria-hidden="true" />
                                            {t(s.label)}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>

                <div className="mt-14 rounded-2xl border border-white/5 bg-nx-alt p-6 lg:p-7" data-testid="risk-disclaimer">
                    <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] text-nx-mute" data-testid="disclaimer-title">
                        {t("Crypto Risk Disclaimer")}
                    </h3>
                    <p className="mt-3 max-w-4xl text-xs leading-relaxed text-nx-mute" data-testid="disclaimer-text">
                        {t("Cryptocurrency and digital asset activities involve inherent risks, including market volatility, liquidity risk, smart-contract risk and potential loss of funds. Information presented on this website is for informational purposes only and should not be considered financial, investment or trading advice. Users should conduct their own research and understand the risks before participating in any digital asset or blockchain-related activity.")}
                    </p>
                </div>

                <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-7 sm:flex-row sm:items-center">
                    <p className="text-xs font-semibold text-nx-mute" data-testid="footer-copyright">{t("© 2026 NEXORA GLOBAL. ALL RIGHTS RESERVED.")}</p>
                    <p className="text-xs text-nx-mute">{t("Global IT & Blockchain Solutions")}</p>
                </div>
            </div>
        </footer>
    );
};
